import Button from '@components/_Layout/Controls/Button';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { ExitToAppOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { sortBy } from '@utils/arrays';
import { TNavigationAreaPath } from '../NavigationArea/NavigationArea';
import { useAuth, useSession } from '@hooks';
import { redirectTo } from '@utils/tools';


type IndexAreaProps = {
  title: string,
  navigationPaths: TNavigationAreaPath[]
};

const languagesVarsCodes = [
  "LANG_neobooking_disconnection_in_progress", //Déconnexion en cours...
  "LANG_neobooking_atm_disconnected", //Vous êtes maintenant déconnecté
  "LANG_neobooking_home", //Accueil
  "LANG_neobooking_welcome", //Bonjour
  "LANG_neobooking_logout", //Déconnection
]

const IndexArea: React.FC<IndexAreaProps> = ({ title, navigationPaths }) => {

  /* Hooks */
  const { user, signout } = useAuth()
  const { getLanguageVarValue } = useSession();

  /* State */
  const [isLogout, setIsLogout] = useState<boolean>(false)

  const handleSignout = () => {
    setIsLogout(true);
    const toastLogout = toast.loading(getLanguageVarValue("LANG_neobooking_disconnection_in_progress"))
    signout((err) => {
      if (!err) {
        toast.success(getLanguageVarValue("LANG_neobooking_atm_disconnected"), {
          id: toastLogout
        })
        redirectTo(window.location.origin);
      }
      else toast.error(err.message, {
        id: toastLogout
      })
      setIsLogout(false)
    })
  }

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_atm_disconnected")}</span>

    <div className="tw-my-6">
      <p>{getLanguageVarValue("LANG_neobooking_welcome")} <span className='tw-font-semibold'>{user?.firstName} {user?.lastName}</span></p>
      <p>{title}</p>

      <div className="tw-my-6 tw-max-w-5xl">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-2 tw-auto-rows-fr">
          {sortBy(navigationPaths, x => x.order).map((navigationPath, index) => {
            return <Link to={navigationPath.to} key={`area_link_${index}`}>
              <div className='tw-h-full tw-p-4 tw-flex tw-items-start tw-flex-col tw-gap-2 tw-border tw-border-gray-200 tw-justify-between tw-rounded hover:tw-shadow hover:tw-border-gray-300 tw-transition-all tw-duration-200 tw-ease-in-out'>
                <div className='tw-mb-4'>
                  {navigationPath.muiIcon && <navigationPath.muiIcon style={{ fontSize: "3rem" }} />}
                </div>
                <div>
                  <div className='tw-font-semibold tw-mb-2'>
                    {navigationPath.name}
                  </div>
                  {navigationPath.description ? <div className='tw-leading-5 tw-text-gray-500'>
                    {navigationPath.description}
                  </div> : <div>&nbsp;<br />&nbsp;</div>}
                </div>
              </div>
            </Link>
          })}
          <Button disabled={isLogout} onClick={handleSignout} type="button" className={`tw-h-full tw-p-4 tw-flex tw-items-start tw-flex-col tw-gap-2 tw-border tw-border-gray-200 tw-justify-between tw-rounded hover:tw-shadow hover:tw-border-gray-300 tw-transition-all tw-duration-200 tw-ease-in-out`}>
            <div className='tw-mb-4'>
              <ExitToAppOutlined style={{ fontSize: "3rem" }} />
            </div>
            <div>
              <div className='tw-font-semibold tw-mb-2'>
                {isLogout ? getLanguageVarValue("LANG_neobooking_disconnection_in_progress") : getLanguageVarValue("LANG_neobooking_logout")}
              </div>
              <div className='tw-leading-5 tw-text-gray-500'>
                &nbsp;
                <br />
                &nbsp;
              </div>
            </div>
          </Button>
        </div>
      </div>
    </div>
  </div>;
};

IndexArea.propTypes = {
  //
};

export default IndexArea;
